import React, { useEffect, useState } from "react";
import { Download } from "lucide-react"

const BASE = "https://webhook.harmonyalgo.com/api";


const downloadImages = async (urls) => {
    try {
      for (let url of urls) {
        url = "https://webhook.harmonyalgo.com/images/" + url.filename
        const response = await fetch(url);
        const blob = await response.blob();
        
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        
        // Extract filename from URL or use a default
        const filename = url.split('/').pop() || 'image.jpg';
        link.download = filename;
        
        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up
        window.URL.revokeObjectURL(link.href);
      }
    } catch (error) {
      console.error('Error downloading images:', error);
    }
  };



const Row = ({ item, formatDate }) => {
  return (
    <tr
      key={item.id}
      className="hover:bg-zinc-800/50 transition-colors"
    >
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        {item.symbol}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        <a href={"https://webhook.harmonyalgo.com/images/" + item.filename} target="_blank" rel="noreferrer">{item.filename}</a>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        {formatDate(item.created_at)}
      </td>
    </tr>
  );
};

const Images = ({ formatDate }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(`${BASE}/images`);
      const resJson = await res.json();
      setTableData(resJson);
    };
    fetchData();
  }, []);

  return (
    <>
      {tableData.map((item) => (
      <div key={item.date}>
        <div className="flex justify-between">
          <h2 className="mx-6 my-4 text-zinc-500">{item.date}</h2>
          <button
            className="p-1 text-zinc-400 text-sm"
            onClick={() => {downloadImages(item.images)}}
          >
            <Download />
          </button>
        </div>
        <div className="mb-12 rounded-lg border border-zinc-800 bg-zinc-900">
          <div className="overflow-x-auto">
            <table className="w-full">
              <tbody className="divide-y divide-zinc-800">
                {item.images.map((image) => (
                  <Row
                    key={image.id}
                    item={image}
                    formatDate={formatDate}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      ))}
    </>
  )
}

export { Images }
